<template>
  <div>
    <!-- NProgress 顶部进度条 — 在 requestCount 从 0→1 时启动，回 0 时完成 -->
    <!-- 浮动非阻塞 loading 指示器 -->
    <transition name="loading-fade">
      <div v-show="showIndicator" class="gl-loading-indicator">
        <span class="gl-spinner"></span>
        <span class="gl-text">请求中…</span>
      </div>
    </transition>
  </div>
</template>

<script>
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import { mapState } from "vuex";

// NProgress 配置：细条、无转圈
NProgress.configure({
  showSpinner: false,
  minimum: 0.1,
  speed: 300,
});

export default {
  name: "GlobalLoading",
  computed: {
    ...mapState("loading", ["requestCount", "submitMode"]),
    /**
     * 浮动「请求中…」指示器 — 只在提交模式下显示
     * 查询模式（搜索/查询）表格已有 v-loading，避免重复
     */
    showIndicator() {
      return this.submitMode && this.requestCount > 0;
    },
  },
  watch: {
    requestCount(val, oldVal) {
      if (val > 0 && oldVal === 0) {
        // 第一个请求发出 → 开始 NProgress
        NProgress.start();
      } else if (val === 0 && oldVal > 0) {
        // 所有请求都返回了 → 完成 NProgress
        NProgress.done();
      }
    },
  },
};
</script>

<style scoped>
/* ---------- 浮动非阻塞指示器 ---------- */
.gl-loading-indicator {
  position: fixed;
  top: 18%;
  left: 50%;
  transform: translateX(-50%);
  z-index: 99999;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 10px 20px;
  border-radius: 24px;
  background: rgba(0, 0, 0, 0.75);
  color: #fff;
  font-size: 14px;
  line-height: 1;
  user-select: none;
  pointer-events: none; /* 不阻挡交互 */
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15);
}

/* 旋转动画 */
.gl-spinner {
  display: inline-block;
  width: 18px;
  height: 18px;
  border: 2.5px solid rgba(255, 255, 255, 0.3);
  border-top-color: #fff;
  border-radius: 50%;
  animation: gl-spin 0.7s linear infinite;
  flex-shrink: 0;
}

@keyframes gl-spin {
  to {
    transform: rotate(360deg);
  }
}

.gl-text {
  letter-spacing: 0.5px;
}

/* ---------- 过渡动画 ---------- */
.loading-fade-enter-active,
.loading-fade-leave-active {
  transition: opacity 0.25s ease;
}
.loading-fade-enter,
.loading-fade-leave-to {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/GlobalLoading.vue